import React, { useState } from "react";

import { Button, Flex, Modal, Tooltip, Typography } from "components";

type ResetDraftButtonProps = {
  onResetDraft: () => Promise<void>;
  isDraftVersion: boolean;
  hasDraftVersion: boolean;
  canEdit: boolean;
  className?: string;
};

export const ResetDraftButton = ({ onResetDraft, isDraftVersion, hasDraftVersion, canEdit, className }: ResetDraftButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleOk = async () => {
    try {
      await onResetDraft();
      setOpen(false);
    } catch {
      // error message handled by mutation's onError
    }
  };

  return (
    <>
      <Tooltip
        className={className}
        title={
          !hasDraftVersion
            ? "Create a new draft from the latest published version."
            : "Reset all draft tables to the latest published version. Any unpublished changes will be lost."
        }
      >
        <Button type="secondary" disabled={(!isDraftVersion && hasDraftVersion) || !canEdit} onClick={() => setOpen(true)} className={className}>
          {!hasDraftVersion ? "Create draft" : "Reset draft"}
        </Button>
      </Tooltip>
      <Modal
        title="Reset draft"
        content={
          <Flex vertical gap={16}>
            <Typography variant="paragraph-m">This will reset all drafts to the latest published version. Any unpublished changes will be lost.</Typography>
            <Typography variant="paragraph-m" bold>
              Warning: This may affect other users work!
            </Typography>
          </Flex>
        }
        showModal={open}
        okText="Reset"
        okButtonProps={{ danger: true }}
        onOk={handleOk}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};
